/**
 * WordPress dependencies
 */
import { useEffect, useState } from "@wordpress/element";
import { doAction, applyFilters } from "@wordpress/hooks";
import { useSelect } from '@wordpress/data';

import { softMinifyCssStrings } from "../helpers/miniHelperFuncs"

export const StyleComponent = (props) => {
    const {
        attributes,
        setAttributes,
        desktopAllStyles,
        tabAllStyles,
        mobileAllStyles,
        blockName
    } = props;

    const {
        blockMeta,
        resOption,
    } = attributes

    const [styleObject, setStyleObject] = useState({
        desktop: desktopAllStyles,
        tab: tabAllStyles,
        mobile: mobileAllStyles
    });

    // Set All Style in "styleObject"
    useEffect(() => {
        const styles = {
            desktop: desktopAllStyles,
            tab: tabAllStyles,
            mobile: mobileAllStyles,
        }
        setStyleObject(applyFilters(`eb-style-object_${blockName.replace(/\//g, '_')}`, styles, attributes, setAttributes))
    }, [attributes]);

    // Set All Style in "blockMeta" Attribute
    useEffect(() => {
        if (JSON.stringify(blockMeta) != JSON.stringify(styleObject)) {
            setAttributes({ blockMeta: styleObject });
        }
    }, [styleObject])

    return (
        <style>
            {`
				${styleObject.desktop}

				/* mimmikcssStart */

				${resOption === "Tablet" ? styleObject.tab : " "}
				${resOption === "Mobile" ? styleObject.tab + styleObject.mobile : " "}

				/* mimmikcssEnd */

				@media all and (max-width: 1024px) {

					/* tabcssStart */
					${softMinifyCssStrings(styleObject.tab)}
					/* tabcssEnd */

				}

				@media all and (max-width: 767px) {

					/* mobcssStart */
					${softMinifyCssStrings(styleObject.mobile)}
					/* mobcssEnd */
				}
			`}
        </style>
    )

}
